import "reflect-metadata";
import "./by/gamefactory/utils/array.extensions";
import { BlockCutCleaner } from "./by/gamefactory/blockCutCleaner/BlockCutCleaner";

function start(): void {
    const game = new BlockCutCleaner();
    document.body.appendChild(game.view as HTMLCanvasElement);
    game.launch("assets/manifest.json");
    // @ts-ignore
    globalThis.__PIXI_APP__ = game;
}

start();